/**
 * CRM deal stage move + installation_date helpers.
 */

import { apiUrl } from "@/lib/api-client";

export type MoveDealStageOptions = {
  stageId: string;
  keepSubpipeline?: boolean;
  pipelineId?: string | null;
  installationDate?: string | null;
};

export class MissingInstallationDateError extends Error {
  readonly code = "missing_installation_date";

  constructor(message?: string) {
    super(message || "missing_installation_date");
    this.name = "MissingInstallationDateError";
  }
}

export async function patchDealInstallationDate(
  dealId: string,
  installationDate: string,
): Promise<void> {
  const r = await fetch(apiUrl(`/api/crm/deals/${dealId}`), {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({ installationDate }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error((body as { message?: string }).message || `PATCH failed ${r.status}`);
  }
}

export async function moveDealStage(dealId: string, options: MoveDealStageOptions): Promise<unknown> {
  const r = await fetch(apiUrl(`/api/crm/deals/${dealId}/stage?_=${Date.now()}`), {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      stageId: options.stageId,
      keepSubpipeline: options.keepSubpipeline,
      pipelineId: options.pipelineId ?? undefined,
      installationDate: options.installationDate ?? undefined,
    }),
  });
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    if ((body as { error?: string }).error === "missing_installation_date") {
      throw new MissingInstallationDateError((body as { message?: string }).message);
    }
    throw new Error((body as { message?: string }).message || `Stage move failed ${r.status}`);
  }
  return r.json();
}

export function todayYmdLocal(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function getDealInstallationDateFromRow(deal: Record<string, unknown> | null | undefined): string | null {
  if (!deal) return null;
  const raw = deal.installationDate ?? deal.installation_date;
  if (raw == null || raw === "") return null;
  return String(raw).split("T")[0];
}
